import * as _ from 'lodash';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ProgressService } from '@app/core/services/progress.service';
import { FileProgress } from '@app/core/models/shared/file-progress.model';
import { FileDownloadService } from '@app/core/services/filedownload.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit, OnDestroy {

  requestId: string;
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  progress: number = 0;
  delegate: NodeJS.Timeout;
  errorCount: number = 0;
  isDownloading: boolean = false;
  isLoading: boolean = false;

  fileProgress: FileProgress = null;

  constructor(
    private dialogRef: MatDialogRef<ProgressComponent>,
    public dialog: MatDialog,
    private progressService: ProgressService,
    private fileDownloadService: FileDownloadService,
    @Inject(MAT_DIALOG_DATA) data) {
    this.requestId = data.requestId;
  }

  ngOnInit(): void {
    this.delegate = setInterval(() => {
      if (this.progress >= 100) {
        clearInterval(this.delegate);
        this.progress = 100;
        return;
      }

      this.progressService.getProgress(this.requestId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((progress: number) => {
          this.progress = progress;
        }, _ => {
          if (this.errorCount++ >= 3) {
            this.onCancel();
          }
        });
    }, 750);

    this.isDownloading = true;

    this.fileDownloadService.fileProgressed$
      .pipe(takeUntil(this.unsubscribe$),
        filter(fileProgress => !_.isNil(fileProgress)))
      .subscribe((fileProgress: FileProgress) => {
        if (this.isDownloading) {
          clearInterval(this.delegate);
          this.isDownloading = false;
        }

        this.isLoading = true;
        this.fileProgress = fileProgress;
        this.progress = Math.round(fileProgress.progressPercent);
      })
  }

  ngOnDestroy() {
    clearInterval(this.delegate);
    this.unsubscribe$.next(true);
  }

  onCancel() {
    clearInterval(this.delegate);
    this.progress = 100;
    this.close(false);
  }

  close(isSuccess: boolean) {
    this.dialogRef.close(isSuccess);
  }
}
